import { useEffect } from 'react';

import { useSupportChatStore } from '../supportChatStore.ts';
import { getSessionStorage } from '../sessionStorage/sessionStorage.ts';
import { isAISupportTestVariant } from '../abTests.ts';
import { type SupportChatType } from '../types.ts';

function useSupportChatType({
    isSellerChat,
    overrideChatType,
}: {
    isSellerChat: boolean;
    overrideChatType?: SupportChatType;
}): SupportChatType | null {
    const chatType = useSupportChatStore(state => state.chatType);
    const hasActiveChat = useSupportChatStore(state => state.hasActiveChat);
    const setChatType = useSupportChatStore(state => state.setChatType);

    useEffect(() => {
        const sessionStorage = getSessionStorage();

        if (sessionStorage.activeChat) {
            setChatType(sessionStorage.activeChat);
            return;
        }

        const store = useSupportChatStore.getState();
        const currentChatType = store.chatType;

        if (currentChatType && hasActiveChat) {
            return;
        }

        if (overrideChatType) {
            setChatType(overrideChatType);
            return;
        }

        const isAbTestVariant = isAISupportTestVariant({ isSellerChat });
        setChatType(isAbTestVariant ? 'SIERRA' : 'SALESFORCE');
    }, [overrideChatType, hasActiveChat, isSellerChat, setChatType]);

    return chatType;
}

export { useSupportChatType };
